/**
 * Mapping Definition
 *
 * key = vue2 path name / requested by most of the APIs
 * value = vue3 path name / new schema, used in the frontend and also by the client search
 */
export const mitversicherterPartnerMapping = {
  salutation_id: 'anredeId',
  firstname: 'vorname',
  lastname: 'nachname',
  title: 'titel',
  birthday: 'geburtsdatum',
  berufsgruppe: 'berufsgruppe',
  jobname: 'beruf',
};

export type MitversicherterPartnerMappingKeys =
  keyof typeof mitversicherterPartnerMapping;
